import { formatDate } from 'utils/date'

export const TOGGLE_PREFIX = 'guru-ks-fe-toggle--'
export const TOGGLE_KEYS = {
  REVAMP_KS_ACTIVE_ENABLED: 'revamp-ks-active-enabled',
  TAMBAH_BCKS_SELEKSI_ENABLED: 'tambah-bcks-seleksi-enabled',
  DASBOR_PENGAJUAN_PERUBAHAN_ENABLED: 'dasbor-pengajuan-perubahan-enabled',
  DASBOR_PENGAJUAN_PERUBAHAN_CEK_RINCIAN_ENABLED:
    'dasbor-pengajuan-perubahan-cek-rincian-enabled',
  PENYESUAIAN_VERVAL_PERIODISASI_ENABLED:
    'penyesuaian-verval-periodisasi-enabled',
}

export const URL_HELPDESK =
  'https://pusatinformasi.rumahpendidikan.kemendikdasmen.go.id/hc/id/categories/52398660479513-SIM-KSPSTK'

export const DEFAULT_ERROR_MESSAGE =
  'Terjadi kesalahan pada sistem. Silahkan coba beberapa saat lagi.'

export const ERROR_MESSAGE_FAILED_UPLOAD = 'Gagal mengunggah file'

export const DATE_CUTOFF_LAPORAN_KEMENDAGRI = '2024-05-02'

export const MSG_LAPORAN_KEMENDAGRI = `Sesuai dengan Surat Edaran Bersama 3 Menteri Nomor 1 Tahun 2024, mulai tanggal ${formatDate(
  DATE_CUTOFF_LAPORAN_KEMENDAGRI
)} seluruh pengangkatan dan rotasi mutasi Kepala Sekolah wajib dilaporkan ke Kemendagri.`
